import React from 'react'

export default function IdentificacionProcesosPanel() {
    return (
        <div>
            <iframe
                style={{ width: '99vw', height: '88vh' }}
                title='identificacion-procesos'
                src="https://geologiaconce.maps.arcgis.com/apps/dashboards/44b9c22dddfe4cfdba519b7b7807478d"
            >

            </iframe>
        </div>
    )
}
